export default class TimeRange {
    constructor(start, end) {
        if (!end.isAfter(start)) {
            throw new Error('End must be after start.');
        }

        this.start = start;
        this.end = end;
    }

    overlaps(other) {
        return this.start < other.end && this.end > other.start;
    }

    diffInMinutes() {
        return this.start.durationInMinutes(this.end);
    }
}
